import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import setActiveTopMenuDropdownOperation from 'editor/src/store/app/operation/setActiveTopMenuDropdownOperation';
import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import alignSelectedMediaOperation, {
  AlignmentDirection,
} from 'editor/src/store/design/operation/align/alignSelectedMediaOperation';
import { StructureIndex } from 'editor/src/store/design/types';
import saveUndoRedoStateOperation from 'editor/src/store/editorModules/undoRedo/operation/saveUndoRedoStateOperation';
import { useDispatch } from 'editor/src/store/hooks';

import ControlButton from 'editor/src/component/ControlButton';
import { useIsMobile } from 'editor/src/component/useDetectDeviceType';

import AlignmentReferenceContext from '../AlignmentReferenceContext';

import styles from './index.module.scss';

interface Props {
  icon: React.ReactElement;
  alignTo: AlignmentDirection;
  structureIndexes: StructureIndex[];
  keepTopDropdown?: boolean;
}

function AlignActionButton({ icon, alignTo, structureIndexes, keepTopDropdown = false }: Props) {
  const dispatch = useDispatch();
  const reference = useContext(AlignmentReferenceContext);
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  const handleClick = () => {
    batch(() => {
      if (!keepTopDropdown) {
        dispatch(setActiveTopMenuDropdownOperation(undefined));
      }

      dispatch(saveUndoRedoStateOperation('Align element'));

      dispatch(alignSelectedMediaOperation(structureIndexes, alignTo, reference));
    });
  };

  return (
    <ControlButton className={styles.alignTabButton} onClick={handleClick} stopPropagation>
      {icon}
      {!isMobile && t(`editor-${alignTo}`)}
    </ControlButton>
  );
}

export default React.memo(AlignActionButton);
